// extracted by mini-css-extract-plugin
module.exports = {"selections":"GuidelineDrawer-module__selections___1b4Dd"};